// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
     apiKey: "AIzaSyDYw-RFKQbtSwgOeUPbWlDYvFimD_IMIy8",
    authDomain: "fairchain.firebaseapp.com",
    databaseURL: "https://fairchain.firebaseio.com",
    projectId: "fairchain",
    storageBucket: "fairchain.appspot.com",
    messagingSenderId: "110083516278",
    appId: "1:110083516278:web:6d00cca61a897e32fc7c57",
    measurementId: "G-3JTK29Y8X1"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
